import { DownloadType as l, DownloadStatus as s } from "../../constants/download.js";
import { platformSchema as d } from "../../../temp-lib/deserialize/yup/platform.js";
import * as e from "ramda";
import * as t from "yup";
const u = t.object({
  url: t.string().default(""),
  lastUpdated: t.number().default(0),
  version: t.string().default("0.0.0")
}).when(
  ["$data", "$info"],
  (o, r) => {
    const n = e.propOr({}, "client_version", r), a = e.propOr({}, o.platform.type, n);
    switch (o.type) {
      case l.Store:
      case l.Mobile: {
        const p = e.propOr("", "url", o);
        return t.object().default({
          url: p,
          lastUpdated: e.propOr(0, "last_updated", r),
          version: e.propOr("0.0.0", "msg", a)
        });
      }
      case l.Direct:
      default:
        return t.object().default({
          url: e.propOr("", "binary_url", a),
          lastUpdated: e.propOr(0, "last_updated", r),
          version: e.propOr("0.0.0", "msg", a)
        });
    }
  }
), i = t.mixed().oneOf(Object.values(s)).default(s.Ready), f = t.object({
  build: u,
  imageOnly: t.boolean().default(!1),
  name: t.string().default(""),
  platform: d,
  status: i,
  statusText: t.string().default("")
}).from("image_only", "imageOnly").from("status_text", "statusText").noUnknown(!0);
export {
  f as downloadInfoSchema
};
//# sourceMappingURL=download.js.map
